import "./styles/ProgressBar.scss";

type Props = {
  value: number;
  className?: string;
}

const CLASS_PREFIX = `ws-widgets-progress-bar`;

const ProgressBar = ({ value, className }: Props) => {
  const percentage = Math.max(0, Math.min(100, value));

  return (
    <div
      className={ `${ CLASS_PREFIX }${ className ? ` ${ className }` : `` }` }
      role={ `progressbar` }
      aria-valuemin={ 0 }
      aria-valuemax={ 100 }
      aria-valuenow={ percentage }
    >
      <div className={ `${ CLASS_PREFIX }__bar` } style={ { width: `${ percentage }%` } }/>
    </div>
  );
}

export default ProgressBar;
